import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';

export function RatingStarsCount({
  ratingAverage,
  ratingCount,
  starsColor = 'success',
  starsWrapperClass = 'me-0_25',
  starClass = undefined,
  ratingCountClass = null,
}) {
  const isRatingAverageToShow = ratingAverage > 0;
  const isRatingCountToShow = ratingCount > 0;

  return (
    <Fragment>
      {isRatingAverageToShow && (
        <RatingStars
          rating={ratingAverage}
          starClass={starClass}
          className={classnames(`text-${starsColor}`, starsWrapperClass)}
        />
      )}
      <span className={ratingCountClass}>
        {isRatingCountToShow ? (
          <Fragment>
            ({ratingCount}
            <span className="visually-hidden">&nbsp; reviews total</span>)
          </Fragment>
        ) : (
          ''
        )}
      </span>
    </Fragment>
  );
}

RatingStarsCount.propTypes = {
  ratingAverage: PropTypes.number.isRequired,
  ratingCount: PropTypes.number.isRequired,
  ratingCountClass: PropTypes.string,
  starClass: PropTypes.string,
  starsWrapperClass: PropTypes.string,
  starsColor: PropTypes.oneOf([
    'danger',
    'info',
    'link',
    'primary',
    'secondary',
    'success',
    'warning',
    'primary-darker',
    '',
  ]),
};
